// extracted by mini-css-extract-plugin
module.exports = {"light-animation":"HomeContentOne_light-animation__3izd9"};